import {
  Toolbar,
  Box
} from "@mui/material";
import StyledAppBar from "./StyledAppBar";
import appHeaderImage from '../app-header.png';

export default function PublicBar() {

  const appName = process.env.REACT_APP_NAME || "My App";

  return (
    <>
      <StyledAppBar position="static">
        <Toolbar>
          <Box
              component="div"
              sx={{
                height: 40, // adjust size
                width: 'auto',
                mr: 2, // margin-right for spacing
                flexGrow: 1,
                display: "flex",     // make it a flex container
                alignItems: "center" // vertical centering
              }}
            >
              <Box
                component="img"
                src={appHeaderImage}
                alt="Animora Vet Hub"
                sx={{
                  height: 34, // adjust size
                  width: 'auto',
                  mr: 2, // margin-right for spacing
                }}
              />
            </Box>
        </Toolbar>
      </StyledAppBar>
    </>
  );
}
